var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import errorHandler from "@/utilities/errorHandler";
import useAdminStore from "@/services/store/useAdminStore";
import { isProtectedActionError } from "@/api/RequestAxios/ProtectedActionError";
import { MixpanelEvents } from "../mixpanel/events";
var useErrorHandler = function () {
    var adminNotification = useAdminStore().adminNotification;
    try {
        return function (error, notification, mixpanelMessage, mixpanelPayload) {
            if (mixpanelMessage) {
                MixpanelEvents.errorEvent(mixpanelMessage, {
                    error: mixpanelPayload || error || undefined,
                });
            }
            if (error && isProtectedActionError(error))
                return;
            if (notification) {
                adminNotification.add(__assign(__assign({}, notification), { message: error
                        ? errorHandler(error, notification === null || notification === void 0 ? void 0 : notification.message)
                        : notification === null || notification === void 0 ? void 0 : notification.message, type: adminNotification.types.ERROR }));
            }
        };
    }
    catch (error) {
        MixpanelEvents.errorEvent("Error in useErrorHandler", {
            payload: error,
        });
        return function (error) {
            console.error("Error in useErrorHandler:", error);
        };
    }
};
export default useErrorHandler;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRXJyb3JIYW5kbGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlRXJyb3JIYW5kbGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQ0EsT0FBTyxZQUFZLE1BQU0sMEJBQTBCLENBQUM7QUFDcEQsT0FBTyxhQUFhLE1BQU0sZ0NBQWdDLENBQUM7QUFFM0QsT0FBTyxFQUFFLHNCQUFzQixFQUFFLE1BQU0seUNBQXlDLENBQUM7QUFDakYsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLG9CQUFvQixDQUFDO0FBRXBELElBQU0sZUFBZSxHQUFHO0lBQ2QsSUFBQSxpQkFBaUIsR0FBSyxhQUFhLEVBQUUsa0JBQXBCLENBQXFCO0lBRTlDLElBQUk7UUFDRixPQUFPLFVBQ0wsS0FBdUIsRUFDdkIsWUFBNkMsRUFDN0MsZUFBOEIsRUFDOUIsZUFBcUI7WUFFckIsSUFBSSxlQUFlLEVBQUU7Z0JBQ25CLGNBQWMsQ0FBQyxVQUFVLENBQUMsZUFBZSxFQUFFO29CQUN6QyxLQUFLLEVBQUUsZUFBZSxJQUFJLEtBQUssSUFBSSxTQUFTO2lCQUM3QyxDQUFDLENBQUM7YUFDSjtZQUVELElBQUksS0FBSyxJQUFJLHNCQUFzQixDQUFDLEtBQUssQ0FBQztnQkFBRSxPQUFPO1lBRW5ELElBQUksWUFBWSxFQUFFO2dCQUNoQixpQkFBaUIsQ0FBQyxHQUFHLHVCQUNoQixZQUFZLEtBQ2YsT0FBTyxFQUFFLEtBQUs7d0JBQ1osQ0FBQyxDQUFDLFlBQVksQ0FBQyxLQUFLLEVBQUUsWUFBWSxhQUFaLFlBQVksdUJBQVosWUFBWSxDQUFFLE9BQWlCLENBQUM7d0JBQ3RELENBQUMsQ0FBQyxZQUFZLGFBQVosWUFBWSx1QkFBWixZQUFZLENBQUUsT0FBTyxFQUN6QixJQUFJLEVBQUUsaUJBQWlCLENBQUMsS0FBSyxDQUFDLEtBQUssSUFDbkMsQ0FBQzthQUNKO1FBQ0gsQ0FBQyxDQUFDO0tBQ0g7SUFBQyxPQUFPLEtBQUssRUFBRTtRQUNkLGNBQWMsQ0FBQyxVQUFVLENBQUMsMEJBQTBCLEVBQUU7WUFDcEQsT0FBTyxFQUFFLEtBQUs7U0FDZixDQUFDLENBQUM7UUFDSCxPQUFPLFVBQUMsS0FBdUI7WUFDN0IsT0FBTyxDQUFDLEtBQUssQ0FBQywyQkFBMkIsRUFBRSxLQUFLLENBQUMsQ0FBQztRQUNwRCxDQUFDLENBQUM7S0FDSDtBQUNILENBQUMsQ0FBQztBQUVGLGVBQWUsZUFBZSxDQUFDIn0=